export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Featured',
            sort: [
                {
                    field: 'score',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price high to low',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price low to high',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: 'new',
        value: {
            name: 'New',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: 'USD'
}

